import {Button} from '@esgi/ui';
import {styled} from '@esgi/ui/theme';

export const StyledTransferButton = styled(Button, {
	justifyContent: 'start',
	paddingLeft: 14,
});